export const iconFontAwesomeHumanitarianSchoolCircleCheck = (
	<i className="fa-solid fa-school-circle-check"></i>
);
